module.exports = __webpack_public_path__ + "static/media/no_img.3c89e2ae.png";